"use client";
import "./blogCard.scss";
import Image from "next/image";
import dayjs from "dayjs";
import Head from "next/head";
import { useIntl } from "react-intl";
import Link from "next/link";
export default function BlogCard({ blog, isFitNess = false, isHomePage = false }) {
  const intl = useIntl();
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: blog?.title,
    image: [blog?.img?.url],
    datePublished: dayjs(blog?.date).toISOString(),
    description: blog?.descrption,
  };

  const targetUrl = isFitNess
    ? `/fitness-blogs/${blog?.slug}`
    : `/blogs/${blog?.slug}`;

  return (
    <Link href={targetUrl}>
      <div className={`blogCardWrapper ${isHomePage ? 'home-page-card' : ''}`}>
        <Head>
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        </Head>
        <div className="blogImgContainer">
          <Image
            loading="lazy"
            src={blog?.img?.url}
            alt="blog image"
            fill
            style={{ objectFit: "cover" }}
          />
          <div className="dateContainer">
            {dayjs(blog?.date).format("MMM DD, YYYY")}
          </div>
        </div>
        <p className="blogHeading">{blog?.title}</p>
        {/* <p className="truncate blogSubHeading">{blog?.descrption}</p> */}

        {/* <MarkdownComp content={blog?.descrption}/> */}
        <button type="button" className="viewMore">
          {intl.formatMessage({ id: "viewMore" })}
        </button>
      </div>
    </Link>
  );
}
